module.exports = __webpack_public_path__ + "img/p4_2.e428755d.png";